import { OrderOptionsValues } from '@bandido/shared/enums';
import { HotelStatus } from '../../constants';
import { HotelsRequestDTO } from '@bandido/shared/dtos';

export const BoxMinWidth = 250;
export const FilterUrlSplitter = '|';
export const ModStatus = Object.values(HotelStatus);

export enum FilterTypes {
  freeText = 'freeText',
  country = 'country',
  supplier = 'supplier',
  status = 'status',
  name = 'name',
  address = 'address',
  city = 'city',
  hotelId = 'hotelId',
  code = 'code',
  modParentId = 'modParentId',
  sort =  'sort',
  order = 'order',
  page = 'page',
  rowsPerPage = 'rowsPerPage',

}

export const defaultValues: HotelsRequestDTO = {
  country: [],
  supplier: [],
  status: [],
  name: [],
  address: [],
  city: [],
  hotelId: [],
  code: [],
  modParentId: [],
  freeText: '',
  currentPage: 1,
  pageSize: 10,
  sort: 'id',
  order: OrderOptionsValues.asc,
};

export const selectPlaceholderValue = '-';
